import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/app/tablet/warehouse-receiving/soft-received/$goodsReceiptId/_layout/")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/app/tablet/warehouse-receiving/soft-received/$goodsReceiptId/purchase-orders",
      params: { goodsReceiptId: params.goodsReceiptId },
    })
  },
})
